import client from './client';
import {
  WhatsappMessage,
  WhatsappMessageFilters,
  WhatsappMessageResult,
  WhatsappMessageSummary,
  WhatsappTemplateCheck,
} from '../types/whatsappMessage';

// Reconcile the notification templates against what is approved on the WABA.
// A mismatch here is the difference between a message arriving and vanishing.
export async function getTemplateCheck(): Promise<WhatsappTemplateCheck[]> {
  const res = await client.get('/api/admin/whatsapp/template-check');
  return Array.isArray(res.data?.templates) ? res.data.templates : [];
}

const EMPTY_SUMMARY: WhatsappMessageSummary = {
  total_sent: 0,
  total_delivered: 0,
  total_read: 0,
  total_failed: 0,
  delivery_rate: 0,
  templates: [],
};

export interface WhatsappMessageParams extends WhatsappMessageFilters {
  page?: number;
  limit?: number;
}

export async function getMessages(
  params: WhatsappMessageParams = {}
): Promise<WhatsappMessageResult> {
  const limit = params.limit ?? 50;
  const query: Record<string, string | number> = { page: params.page ?? 1, limit };
  if (params.template_name) query.template_name = params.template_name;
  if (params.status) query.status = params.status;
  if (params.phone) query.phone = params.phone;
  if (params.from) query.from = params.from;
  if (params.to) query.to = params.to;

  const res = await client.get('/api/admin/whatsapp/messages', { params: query });
  const data = res.data ?? {};
  const messages: WhatsappMessage[] = Array.isArray(data.messages) ? data.messages : [];
  const pagination = data.pagination ?? {};
  const total: number = pagination.total ?? messages.length;

  return {
    messages,
    summary: data.summary ?? EMPTY_SUMMARY,
    templateNames: Array.isArray(data.template_names) ? data.template_names : [],
    total,
    totalPages: pagination.pages ?? Math.max(1, Math.ceil(total / limit)),
  };
}
